pageId = 'projects-statistics-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $chart = $page.find('#chart')
  chartData = $chart.data('chart-options')
  chartSeries = chartData.series
  chartOptions = Object.assign {}, {
    title:
      show: false
    grid:
      bottom: 30
      left: 20
      right: 20
      top: 10
    tooltip:
      trigger: 'axis'
      axisPointer:
        type: 'line'
        axis: 'x'
        z: 2
        label:
          show: true
          backgroundColor: 'transparent'
          margin: 5
          textStyle:
            color: '#555'
        lineStyle:
          type: 'dashed'
          opacity: 0.3
          color: '#000'
      formatter: (series) ->
        html = series.map (s) ->
          "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#{s.color};'></span>#{s.value} #{s.seriesName}"
        html.reverse().join('<br>')
    xAxis:
      type: 'category'
      boundaryGap: false
      axisTick:
        show: false
      axisLabel:
        show: false
      axisLine:
        lineStyle:
          color: '#CCCCCC'
          width: 4
      data: chartData.xAixs.data
    yAxis:
      show: false
    series: chartSeries
  }
  chart = tower.chart($chart, chartOptions)
  echart = chart.echart
  echart.dispatchAction({type: 'showTip', seriesIndex: 0, dataIndex: (chartOptions.xAxis.data.length - 1)})

  $('.chart-toggle-series')
    .on 'click', (e) ->
      $(e.currentTarget).toggleClass('closed')
      disableSeriesIndex = []
      $('.chart-toggle-series.closed').each (index, toggle) ->
        disableSeriesIndex.push(parseInt($(toggle).data('series-index')))
      enableSeries = chartSeries.filter (series, index) ->
                      disableSeriesIndex.indexOf(index) == -1
      options = echart.getOption()
      options.series = enableSeries
      echart.setOption(options, {notMerge: true})

$ ->
  tower.stack.on 'pageunload', (e, $page, pageParams) ->
    return unless $page.is("##{pageId}")
    $chart = $page.find('#chart')
    chart = $chart.data('chart')
    chart?.destroy()
    $page.find('.chart-toggle-series.closed').removeClass('closed')
